import React, { useState, useEffect } from "react";
import { Nav, Row, Col, Button, Modal, Form } from "react-bootstrap";
import { NavLink } from "react-router-dom";
//import {Sidebar, Menu, MenuItem, useProSidebar, ProSidebarProvider  } from 'react-pro-sidebar';
import "./leftpanel.css";
import {
  Home_Img,
  Plane_Img,
  Shopping_Img,
  User_Img,
  Dollar_Img,
  Calendar_Img,
  Palm_Img,
  Relation_Img,
} from "../../assets/images";
import { message } from "antd";
import apiConfig from "../../config/api.config";
import axios from "../../axios/axios";
import TravelPortalModel from "../TravelPortalModal";
import LoadingOverlay from "react-loading-overlay";

const Leftpanel = (props) => {
  const [show, setShow] = useState(false);
  const [first, setFirst] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [last, setLast] = useState("");
  const [address, setAddress] = useState("");
  const [loadTravel, setLoadTravel] = useState("");
   const [arrivia_password, setArriviaPassword] = useState("");
   const [arriviaLoader , setArriviaLoader] = useState(false);
  const [user, setUser] = useState(
    localStorage.getItem("userDetails")
      ? JSON.parse(localStorage.getItem("userDetails"))
      : null
  );
  const [arriviaUserId, setArriviaUserId] = useState(
    user ? user.arriviaUserId : null
  );

  const [loading, setLoading] = useState(false);

  const modalClose = () => {
    setLoadTravel(false);
    setShow(false);
  };

  const handleFirst = (event) => {
    switch (event.target.name) {
      case "first":
        setFirst(event.target.value);
        break;
      case "last":
        setLast(event.target.value);
        break;

      case "address":
        setAddress(event.target.value);
        break;
      case "city":
        setCity(event.target.value);
        break;
      case "phone":
        setPhone(event.target.value);
        break;
      case "arrivia_password":
        setArriviaPassword(event.target.value);
        break;

      default:
        setCountry(event.target.value);
        break;
    }
  };

  const modalShow = () => setShow(true);

  const arriviaRegister = async () => {
    let isRegistered = false;
    if (!first || !phone || !city || !country || !last || !address || !arrivia_password) {
      console.log(first);
      message.warning("Please fill up the form properly");
    } else {
     if(arrivia_password.length < 8) {
        message.warning("Password should be at least 8 characters");
        return;
      }
      setArriviaLoader(true);
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("AuthToken")}`,
        },
      };

      let data = {
        firstName: first,
        lastName: last,
        phone,
        country,
        city,
        address,
        password: arrivia_password
      };
      await axios
        .post(`${apiConfig.api}user/arrivia_register`, data, config)
        .then((res) => {
          
          if (res.data.status) {
            modalClose();
          setArriviaLoader(false);
            message.warning("Registering to Dashboard, please wait");
            setArriviaUserId(res.data.data);
            let userDetails = JSON.parse(localStorage.getItem("userDetails"));
            console.log(userDetails, "us---");
            userDetails.arriviaUserId = res.data.data;
            console.log(userDetails, "us");
            localStorage.setItem("userDetails", JSON.stringify(userDetails));
            isRegistered = true;
            // arriviaLogin();
            window.open(apiConfig.arriviaRedirectUrl + res.data.data, "_blank");
          } else {
            setArriviaLoader(false);
            message.error("Something went wrong. Login failed!");
          }
        })
        .catch((err) => {
          setArriviaLoader(false);
          console.log("err", err);
          message.error(
            err.response.data.message ??
              "Something went wrong. Please try again letter"
          );
        });

      if (isRegistered) {
        modalClose();
        setArriviaLoader(false);
        message.success("User is successfully registered");
      } else {
        setArriviaLoader(false);
      }
    }
  };

  const arriviaLogin = async () => {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("AuthToken")}` },
    };
    if (!arriviaUserId) {
      // window.open("/", "_self");
      modalShow();
      return 0;
    }
    setLoadTravel(true);
    // else message.success("Red, please wait");
    message.success("Redirecting to dashboard. Please wait...");
    await axios
    .post(`${apiConfig.api}user/arrivia_login`, {}, config)
    .then((res) => {
      if (res.data.status) {
        setLoadTravel(false);
        window.open(apiConfig.arriviaRedirectUrl + res.data.data);
          // window.open(apiConfig.arriviaRedirectUrl + res.data.data, "_blank");
        } else {
          message.error("Something went wrong. Login failed!");
        }
      })
      .catch((err) => {
        console.log("err", err);
        setLoadTravel(false);
        message.error(
          err.response.data.message ??
            "Something went wrong. Please try again letter"
        );
      });
  };

  return (
    <div className="left_panel_partts">
      <Nav as="ul" className="ml-auto mr-auto nav_dash">
        <Nav.Item as="li">
          <NavLink exact to="/">
            <span className="dasg__imgg">
              <img src={Home_Img} alt="" />
            </span>
            <span>Home</span>
          </NavLink>
        </Nav.Item>

        <Nav.Item as="li">
          <NavLink
            to="#"
            // onClick={() => {
            //   props.arriviaLogin();
            // }}
            onClick={arriviaLogin}
            exact
          >
            <span className="dasg__imgg">
              <img src={Plane_Img} alt="" />
            </span>
            <span>Travel Deals</span>
            
          </NavLink>
        </Nav.Item>
        <Nav.Item as="li">
          <a
            href={`${
              process.env.REACT_APP_ENV === "PRODUCTION"
                ? "https://tapi.tripvaletincentives.com/user/benifithub"
                : "https://apistaging.tripvalet.com/user/benifithub"
            }`}
            target="_blank"
          >
            <span className="dasg__imgg">
              <img src={Shopping_Img} alt="" />
            </span>
            <span>Shopping & Entertainment</span>
          </a>
        </Nav.Item>

        
        {/* <Nav.Item as="li">
          <NavLink
            exact
            to="#"
            onClick={() => {
              window.open("https://www.tripvalet.com/refer-others");
            }}
          >
            <span className="dasg__imgg">
              <img src={Dollar_Img} alt="" />
            </span>
            <span>Get paid to refer a friend</span>
          </NavLink>
        </Nav.Item>
        <Nav.Item as="li">
          <NavLink exact to="/events">
            <span className="dasg__imgg">
              <img src={Calendar_Img} alt="" />
            </span>
            <span>Calendar of Events</span>
          </NavLink>
        </Nav.Item> */}
        <Nav.Item as="li">
          <NavLink
            exact
            to="#"
            onClick={() => {
              window.open("https://www.tripvalet.com/escape-trips");
            }}
          >
            <span className="dasg__imgg">
              <img src={Palm_Img} alt="" />
            </span>
            <span>Escape Trips</span>
          </NavLink>
        </Nav.Item>
        {/* <Nav.Item as="li">
          <NavLink
            reloadDocument
            exact
            to="#"
            onClick={() => {
              window.open("https://affiliate.tripvalet.com/login");
            }}
          >
            <span className="dasg__imgg">
              <img src={Relation_Img} alt="" />
            </span>
            <span>Affiliate Dashboard </span>
          </NavLink>
        </Nav.Item> */}
        <Nav.Item as="li">
          <NavLink exact to="/affiliate-dashboard">
            <span className="dasg__imgg">
              <img src={Relation_Img} alt="" />
            </span>
            <span>Affiliate Dashboard </span>
          </NavLink>
        </Nav.Item>
        <Nav.Item as="li">
          <NavLink
            exact
            to="/my-account"
            // onClick={() => {
            //   window.open("https://www.tripvalet.com/account/my-account");
            // }}
          >
            <span className="dasg__imgg">
              <img src={User_Img} alt="" />
            </span>
            <span>My Account</span>
          </NavLink>
        </Nav.Item>
      </Nav>
      
      <TravelPortalModel
        show={show}
        modalClose={modalClose}
        first={first}
        last={last}
        phone={phone}
        address={address}
        city={city}
        country={country}
        arrivia_password={arrivia_password}
        arriviaLoader={arriviaLoader}
        handleFirst={handleFirst}
        arriviaRegister={arriviaRegister}
      />
    </div>
  );
};

export default Leftpanel;
